import React from "react";

const RessourceStatusComp = ({ status }) => {
  switch (status) {
    case 4:
      return (
        <i
          className="bx bx-hide fs-4 text-muted"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          data-bs-title="ressource désactivée"
        />
      );
    default:
      return null;
  }
};

export default RessourceStatusComp;
